import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function About() {
  const { content } = useSiteContent();
  const { aboutValues } = content;
  return (
    <main>
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <span className="kicker">Our story</span>
          <h1 className="hero-heading text-white text-5xl md:text-6xl mt-5">Care begins with seeing the whole person.</h1>
          <p className="text-slate-300 text-lg max-w-3xl mx-auto mt-6 leading-relaxed">
            3E DanCare was built around a simple belief: the most meaningful support often looks like a familiar face, a shared laugh, and help with the things that keep a day moving.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div className="rounded-3xl overflow-hidden border border-white/10">
            <img src="https://images.unsplash.com/photo-1762955913084-96ea3f986468?w=1200&q=80" alt="care" className="w-full aspect-[4/3] object-cover" />
          </div>
          <div>
            <span className="kicker">Why 3E</span>
            <h2 className="font-serif-display text-white text-4xl md:text-5xl mt-4 mb-6">Professional enough to trust. Human enough to feel.</h2>
            <p className="text-slate-300 leading-relaxed mb-4">We partner with individuals, families, and referral professionals to make everyday life more manageable at home. Our companions and homemakers support routines while respecting independence, dignity, and personal choice.</p>
            <p className="text-slate-300 leading-relaxed">Every family brings a different rhythm. We listen first, communicate clearly, and help build a plan that feels realistic for the life already being lived.</p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-6">
          {aboutValues.map(v => (
            <div key={v.num} className="card-soft p-8">
              <div className="text-[#c7e34a] font-serif-display text-3xl mb-3">{v.num}</div>
              <h3 className="font-serif-display text-white text-2xl mb-3">{v.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="card-soft p-10 md:p-14 text-center">
            <HeartHandshake className="w-10 h-10 text-[#c7e34a] mx-auto mb-5" />
            <p className="font-serif-display text-white text-2xl md:text-3xl leading-snug max-w-3xl mx-auto">“Care is not one grand gesture. It is the way we make room for someone else to have a good day.”</p>
            <p className="text-slate-400 text-sm mt-6 uppercase tracking-widest">The 3E DanCare promise</p>
          </div>
        </div>
      </section>

      <section className="py-20 text-center">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <h2 className="font-serif-display text-white text-4xl md:text-5xl mb-6">Ready to talk?</h2>
          <p className="text-slate-300 mb-8">Let's figure out what thoughtful support could look like for your home.</p>
          <Link to="/booking" className="btn-lime">Book a consultation <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </main>
  );
}
